import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";
import { Loader } from "lucide-react";
import { hasRole } from "@/lib/types";

const AdminProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, userData, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="h-screen flex items-center justify-center">
        <Loader className="h-8 w-8 animate-spin text-secondary" />
      </div>
    );
  }

  if (!user || !hasRole(userData, "admin")) {
    return <Navigate to="/" />;
  }

  return <>{children}</>;
};

export default AdminProtectedRoute;
